export default __webpack_public_path__ + "static/media/epi-agriculture.29123f2c.jpg";